module.exports = __webpack_public_path__ + "img/bg7.9bc2b404.jpg";